import React from 'react'
import { BasketButton, Spacer, WorkArea } from '@revelrygroup/components'
import classnames from 'classnames'

import Basket from '../../../Basket'
import EventTrackingModel from '../../../models/EventTrackingModel'
import FlowerstoreProducts from '../../../FlowerstoreProducts'
import { ObituarySnippet } from '../../../../types'
import { routes } from '../../../../routes'
import styles from './styles.module.scss'
import useFlowerProductsContext from '../../../../hooks/useFlowerProductsContext'
import { useRouter } from 'next/dist/client/router'
import useCartContext from '../../../../hooks/useCartContext'

interface Props {
  obituary: ObituarySnippet | null
}

const PLP: React.FC<Props> = ({ obituary }) => {
  const { products } = useFlowerProductsContext()
  const { cartID, cart, totalProductQuantity } = useCartContext()
  const router = useRouter()
  const [basketVisible, setBasketVisible] = React.useState(false)
  const onCloseBasket = (): void => {
    setBasketVisible(false)
    document.body.classList.remove('no-scroll')
  }
  const onOpenBasket = (): void => {
    setBasketVisible(true)
    document.body.classList.add('no-scroll')
  }

  React.useEffect(() => {
    if (!obituary.enable_flowerstore) {
      router.replace(routes.obituary(obituary))
    }
  }, [obituary.enable_flowerstore, router])

  React.useEffect(() => {
    EventTrackingModel.trackViewFlowers(products, 'plp')
  }, [])

  return (
    <>
      <WorkArea avoidHeader className={styles.workarea}>
        <Spacer verticalBottom="sm">
          <div className={styles.heading}>
            {totalProductQuantity > 0 && (
              <div className={styles.basketBtnWrapper}>
                <BasketButton
                  className={styles.basketBtn}
                  productCount={totalProductQuantity}
                  onClick={onOpenBasket}
                />
              </div>
            )}

            <h1 className={classnames('h3', styles.title)}>Send Flowers</h1>
          </div>
        </Spacer>

        <FlowerstoreProducts gaTrackingList="plp" obituary={obituary} products={products} />
      </WorkArea>

      {basketVisible && (
        <Basket
          onCheckout={() => {
            EventTrackingModel.trackCheckoutInitiated(cart)
            router.push(routes.shipping(obituary, cartID))
          }}
          onClose={onCloseBasket}
        />
      )}
    </>
  )
}

export default PLP
